import React, { useState } from "react"
import style from './Layout.module.scss'
import { Link } from "gatsby"
import { MDXProvider } from "@mdx-js/react"
import Button from "../ui/Button"
import SequenceDiagram from "../graph/SequenceDiagram"
import GanttDiagram from "../graph/GanttDiagram"
import cx from "classnames"

const Code = ({ children, }) => {
  const child = React.Children.only(children)
  const type = child.props.className.replace(/^language-/, '')
  const code = child.props.children
  const metaString = child.props.metastring
  const options = (metaString ? metaString.split(' ') : [])
    .reduce((acc, option) => ({ ...acc, [option]: true, }), {})

  if (type === 'sequence') {
    return <SequenceDiagram defaultCode={code} {...options} />
  }

  if (type === 'gantt') {
    return <GanttDiagram defaultCode={code} {...options} />
  }


  throw new Error('Unknown language')
}

export default ({ children }) => {
  const [ active, setActive ] = useState(false)
  return (
    <MDXProvider components={{ Button, pre: Code }}>
      <nav className={style.navBar}>
        <div>
          <Link to="/" className={style.item}>GraphUp</Link>
          <div className={cx({ [style.active]: active, })}>
            <div className={cx(style.item, style.dropdown)}>
              Diagrams
              <div>
                <Link to="sequence-diagram">Sequence diagram</Link>
                <Link to="gantt-diagram">Gantt diagram</Link>
              </div>
            </div>
            <Link className={style.item} to="pricing">Pricing</Link>
            <Link className={style.item} to="about">About</Link>
          </div>
          <button className={cx(style.burger, { [style.active]: active, })} onClick={() => setActive((a) => !a)} />
        </div>
      </nav>
      <main className={style.container}>
        {children}
      </main>
      <footer>
        <div>
          <span>© {new Date().getFullYear()} GraphUp</span>
          <Link to="/about">About</Link>
          <a href="https://nicolaskeller.typeform.com/to/HsLUBb" rel="nofollow" >Contact</a>
        </div>
      </footer>
    </MDXProvider>
  )
}
